module.exports = __webpack_public_path__ + "img/yt-card-cutout.5c0ad6c0.png";